// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__kvfEY","navbarScrolled":"Header_navbarScrolled__3SV2W","dropdown":"Header_dropdown__ZNsCx"};